import debounce from 'lodash/debounce';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import { defineComponent, ref, watch, getCurrentInstance, inject, onBeforeMount } from 'vue-demi';
import { OrProgressV3, useElevation, OrToastV3, OrTeleportV3, OrSkeletonCircleV3, OrSkeletonRectV3, OrTagV3, OrButtonV3, OrLoaderV3, OrNotificationV3, OrAvatarV3, OrTextV3, OrTooltipV3, OrIconButtonV3, getAbbreviation, OrInputV3, OrIconV3, useResponsive, OrModalV3, OrMenuItemV3, OrSwitchV3, OrPopoverV3, OrConfirmV3 } from '@onereach/ui-components';
import { useScrollLock } from '@vueuse/core';
import { resolveComponent, openBlock, createElementBlock, createVNode, createCommentVNode, createBlock, withCtx, Transition, createElementVNode, normalizeClass, Fragment, createTextVNode, toDisplayString, renderList, renderSlot, normalizeStyle, withDirectives, vShow } from 'vue';
import { generateFingerPrint } from '@or-sdk/auth';
import assign from 'lodash/assign';
import { defineStore } from 'pinia';
import { A as AuthErrorTypes, T as TokenTypes, e as expireOverlay, a as extractUserRole, M as MfaReqMessage, b as AccountDisabledMessage, P as ProfileMenuTab } from './expireOverlay-eec85325.js';
export { b as AccountDisabledMessage, A as AuthErrorTypes, M as MfaReqMessage, P as ProfileMenuTab, T as TokenTypes, U as UserRoles, e as expireOverlay, a as extractUserRole, g as getAvailableRoles } from './expireOverlay-eec85325.js';
import 'lodash';
import Cookies from 'universal-cookie';
import { useDarkMode } from '@onereach/dark-mode';
import sortBy from 'lodash/sortBy';
import find from 'lodash/find';
import reject from 'lodash/reject';
import noop from 'lodash/noop';
import startCase from 'lodash/startCase';
import isEmpty from 'lodash/isEmpty';
import endsWith from 'lodash/endsWith';
import { Chat } from '@or-sdk/chat';
import isNull from 'lodash/isNull';

var script$b = defineComponent({
  name: 'ExpirationOverlay',
  components: {
    OrProgressV3
  },
  props: {
    lockUsername: {
      type: String,
      required: true
    },
    authUrl: {
      type: String,
      required: true
    },
    username: {
      type: String,
      required: false,
      default: null
    },
    identityProvider: {
      type: Object,
      required: false,
      default: null
    },
    token: {
      type: String,
      required: false,
      default: null
    },
    userId: {
      type: String,
      required: false,
      default: null
    },
    accountId: {
      type: String,
      required: false,
      default: null
    },
    cookiesExpired: {
      type: Boolean,
      required: false,
      default: false
    },
    cookiesAnotherUser: {
      type: Boolean,
      required: false,
      default: false
    },
    cookiesNoRights: {
      type: Boolean,
      required: false,
      default: false
    },
    loginOverlayDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    reloadUrl: {
      type: String,
      required: false,
      default: window.location.origin
    }
  },
  emits: ['onUpdateCookieExpiration'],
  setup(props, {
    emit
  }) {
    const cookiesRenewHandler = () => emit('onUpdateCookieExpiration');
    const sessionExpirationIframe = ref();
    const lockScreen = useScrollLock(document.body, false);
    const cookiePopupOpened = ref(false);
    watch(cookiePopupOpened, value => {
      if (value) {
        lockScreen.value = true;
        useElevation(sessionExpirationIframe);
      } else {
        lockScreen.value = false;
      }
    });
    return {
      cookiePopupOpened,
      lockScreen,
      sessionExpirationIframe,
      throttled: debounce(cookiesRenewHandler, 1000),
      expiredTokenLoading: ref(false)
    };
  },
  data() {
    return {
      isOpened: false,
      iframeBaseUrl: `${this.authUrl}/session-expired`,
      cookieUpdateEvents: ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'],
      iframeUrl: '',
      sessionIframeMounted: false
    };
  },
  watch: {
    cookiesExpired(value) {
      if (value) {
        this.openReloginPopup();
      } else {
        this.closeReloginPopup();
      }
    },
    cookiesAnotherUser(value) {
      if (value) {
        this.openAnotherUserPopup();
      } else {
        this.closeReloginPopup();
      }
    },
    cookiesNoRights(value) {
      if (value) {
        this.openNoRightsPopup();
      } else {
        this.closeReloginPopup();
      }
    }
  },
  mounted() {
    window.addEventListener('message', this.listenIframe);
    forEach(this.cookieUpdateEvents, event => {
      window.addEventListener(event, this.throttled);
    });
  },
  beforeDestroy() {
    window.removeEventListener('message', this.listenIframe);
    forEach(this.cookieUpdateEvents, event => {
      window.removeEventListener(event, this.throttled);
    });
  },
  methods: {
    listenIframe(event) {
      switch (event.data.type) {
        case 'AUTH_SESSION_EXPIRATION_MOUNTED':
          this.sessionIframeMounted = true;
          this.postMessage({
            type: 'AUTH_SESSION_EXPIRATION_TOKEN',
            token: this.token
          });
          break;
        case 'AUTH_SESSION_EXPIRATION_RELOAD':
          this.reload();
          break;
        case 'AUTH_SESSION_EXPIRATION_SUCCESS':
          break;
        case 'EXPIRED_TOKEN_REFRESH':
          this.expiredTokenLoading = event.data.loading;
          break;
      }
    },
    postMessage(payload) {
      if (get(this, 'sessionExpirationIframe.contentWindow.postMessage')) {
        this.sessionExpirationIframe.contentWindow.postMessage(payload, '*');
      }
    },
    reload() {
      // @ts-ignore
      window.location = this.reloadUrl;
    },
    async openReloginPopup() {
      const username = this.lockUsername;
      this.iframeUrl = `${this.iframeBaseUrl}?username=${encodeURIComponent(username)}&userId=${this.userId}&accountId=${this.accountId}`;
      if (this.identityProvider) {
        this.iframeUrl = this.iframeUrl + `&identityProvider=${this.identityProvider.name}`;
      }
      this.cookiePopupOpened = true;
    },
    async openAnotherUserPopup() {
      const username = this.lockUsername;
      this.iframeUrl = `${this.iframeBaseUrl}?username=${encodeURIComponent(username)}&anotherUser=true`;
      this.cookiePopupOpened = true;
    },
    async openNoRightsPopup() {
      const username = this.lockUsername;
      this.iframeUrl = `${this.iframeBaseUrl}?username=${encodeURIComponent(username)}&noRights=true`;
      this.cookiePopupOpened = true;
    },
    closeReloginPopup() {
      if (!this.cookiesExpired && !this.cookiesAnotherUser && !this.cookiesNoRights) {
        this.iframeUrl = '';
        this.cookiePopupOpened = false;
      }
    }
  }
});

const _hoisted_1$a = {
  key: 0,
  class: "refhres-token-loader"
};
const _hoisted_2$7 = ["src"];
function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrProgressV3 = resolveComponent("OrProgressV3");
  return openBlock(), createElementBlock("div", null, [_ctx.expiredTokenLoading ? (openBlock(), createElementBlock("div", _hoisted_1$a, [createVNode(_component_OrProgressV3, {
    type: "linear",
    clor: "primary",
    loading: "",
    class: "w-full max-w-full"
  })])) : createCommentVNode("v-if", true), _ctx.cookiePopupOpened ? (openBlock(), createElementBlock("iframe", {
    key: 1,
    ref: "sessionExpirationIframe",
    src: _ctx.iframeUrl,
    class: "inset-none h-full w-full absolute"
  }, null, 8 /* PROPS */, _hoisted_2$7)) : createCommentVNode("v-if", true)]);
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = ".refhres-token-loader[data-v-6026d621] {\n  position: fixed;\n  top: 46px;\n  right: 0;\n  left: 0;\n  z-index: 200;\n}";
styleInject(css_248z$1);

script$b.render = render$b;
script$b.__scopeId = "data-v-6026d621";
script$b.__file = "src/components/ExpirationOverlay.vue";

function cookieMonitorLogoutCallback$1() {
  this._authCookiesExpired(true);
}
function cookieMonitorLoginCallback$1(newUser) {
  if (!this.userId || get(newUser, 'userId', null) === this.userId) {
    if (this.cookiesExpired) this._authCookiesExpired(false);
    if (this.cookiesAnotherUser) this._authCookiesExpired(true);
  } else {
    if (!this.cookiesAnotherUser) this._authAnotherUser();
  }
  if ((newUser === null || newUser === void 0 ? void 0 : newUser.expire) < Date.now()) {
    expireOverlay.captureClick();
  } else if ((newUser === null || newUser === void 0 ? void 0 : newUser.expire) > Date.now() && expireOverlay.shown) expireOverlay.triggerClick();
}
const initializeAuthStore = authService => {
  return defineStore('auth', {
    state: () => ({
      get token() {
        return authService.getUserToken();
      },
      reactiveToken: null,
      tokenExpireTime: null,
      accountId: null,
      username: null,
      userId: null,
      error: null,
      authorized: null,
      role: null,
      initialPath: null,
      twoFactorCheck: false,
      fingerPrint: null,
      multiUserId: null,
      identityProvider: null,
      cookiesExpired: false,
      cookiesAnotherUser: false,
      cookiesNoRights: false,
      permissions: null,
      isReadonly: null
    }),
    actions: {
      //mutations:
      _authCookiesExpired(value) {
        this.cookiesExpired = value;
        this.cookiesAnotherUser = false;
        this.cookiesNoRights = false;
      },
      _authAnotherUser() {
        this.cookiesExpired = false;
        this.cookiesAnotherUser = true;
        this.cookiesNoRights = false;
      },
      _authNoRights() {
        this.cookiesExpired = false;
        this.cookiesAnotherUser = false;
        this.cookiesNoRights = true;
      },
      _authInit(initState) {
        var _a, _b;
        this.accountId = get(initState, 'accountId', null);
        this.username = get(initState, 'username', null);
        this.userId = get(initState, 'userId', null);
        this.role = get(initState, 'role', null);
        this.authorized = get(initState, 'authorized', null);
        this.error = get(initState, 'error', null);
        this.initialPath = get(initState, 'initialPath');
        this.identityProvider = get(initState, 'identityProvider', null);
        this.multiUserId = get(initState, 'multiUserId');
        this.reactiveToken = get(initState, 'token', null);
        this.tokenExpireTime = get(initState, 'expire', null);
        this.permissions = get(initState, 'permissions', null);
        this.isReadonly = this.role === 'USER' && !!((_b = (_a = this.permissions) === null || _a === void 0 ? void 0 : _a.scope) === null || _b === void 0 ? void 0 : _b.includes('READONLY'));
      },
      _authSuccess(authData) {
        this.accountId = authData.accountId;
        this.username = authData.username;
        this.userId = authData.userId;
        this.role = authData.role;
        this.identityProvider = authData.identityProvider;
        this.authorized = true;
        this.error = null;
        this.multiUserId = authData.multiUserId;
        this.reactiveToken = authData.token;
        this.tokenExpireTime = authData.expire;
      },
      _authError(error) {
        this.error = error;
        this.identityProvider = null;
      },
      _signOut() {
        this.accountId = null;
        this.username = null;
        this.userId = null;
        this.role = null;
        this.authorized = false;
        this.error = null;
        this.initialPath = null;
        this.multiUserId = null;
        this.identityProvider = null;
        this.reactiveToken = null;
        this.tokenExpireTime = null;
      },
      _twoFactorCheck(value) {
        this.twoFactorCheck = value;
      },
      _generateFingerprint(fingerPrint) {
        this.fingerPrint = fingerPrint;
      },
      //actions:
      init({
        initialPath,
        token,
        allowGuestLogin = false,
        shouldNotSaveCookies = false
      }) {
        var _a;
        authService.tokenUpdateCallback = user => {
          this.updateReactiveToken(user);
        };
        // if initial path starts with '/login' then replace it with '/'
        initialPath = initialPath.match(/^\/login/) ? '/' : initialPath;
        let userPromise;
        if (token) userPromise = authService.signInWithToken(token, allowGuestLogin, shouldNotSaveCookies);else if (((_a = authService._getUser) === null || _a === void 0 ? void 0 : _a.expire) < Date.now()) userPromise = authService.refreshUserToken();else userPromise = authService.validateUser();
        return userPromise.then(user => {
          if (!shouldNotSaveCookies) {
            authService.monitorCookie(cookieMonitorLogoutCallback$1.bind(this), cookieMonitorLoginCallback$1.bind(this));
            authService.validateMultiUserToken().catch(console.warn);
          }
          this._authInit(assign({}, user, {
            authorized: true,
            initialPath
          }));
        }).catch(error => {
          var _a, _b, _c;
          if (((_c = (_b = (_a = error.cause) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message.includes('suspended')) || error.message.includes('suspended')) {
            window.location.href = `${authService.authUiUrl}/account/payments`;
            return;
          }
          this._authInit({
            authorized: false,
            initialPath
          });
          if (error.errorType === AuthErrorTypes.noRights) {
            this._authNoRights();
          }
          throw error;
        });
      },
      /**
      * TODO: Remove
      * @deprecated not being used
      */
      signIn({
        credentials,
        keepLoggedIn,
        verificationCode,
        userToken,
        rememberTwoFactor
      }) {
        return authService.signIn({
          credentials,
          long: keepLoggedIn,
          verificationCode,
          userToken,
          rememberTwoFactor
        }).then(async result => {
          if (result.tokenType === TokenTypes.multiUser && !result.twoFactorCheck) {
            result = await authService.multiUserLoginUser({
              accountId: this.accountId,
              id: this.userId,
              long: keepLoggedIn
            });
          }
          if (result.twoFactorCheck) {
            this._twoFactorCheck(true);
          } else {
            this._authSuccess(result);
            authService.monitorCookie(cookieMonitorLogoutCallback$1.bind(this), cookieMonitorLoginCallback$1.bind(this));
          }
          return result;
        }).catch(error => {
          this._authError(error);
        });
      },
      /**
      * TODO: Remove
      * @deprecated not being used
      */
      signOut() {
        authService.signOut();
        authService.stopCookieMonitor();
        this._signOut();
      },
      async generateFingerPrint() {
        const fingerprint = await generateFingerPrint();
        this._generateFingerprint(fingerprint);
      },
      updateCookieExpiration() {
        authService.updateCookieExpiration();
      },
      async getUserNameForLockScreen() {
        return await authService.getUserNameForLockScreen({
          multiUserId: this.multiUserId,
          username: this.username,
          token: this.token
        });
      },
      updateReactiveToken({
        token,
        expire
      }) {
        this.reactiveToken = token;
        this.tokenExpireTime = expire;
      }
    }
  });
};

var en = {
	"Enter user email address": "Enter user email address",
	youHaveUnsaved: "You have unsaved changes. Are you sure you want to discard them?",
	beforeAttachMulti: "Before attaching to profile, please, ensure you don’t have unsaved changes as you will be allowed to log in only with your profile email.",
	beforeAttachMulti2: "If you have users from this account already attached to current profile, they will be merged to one with the highest role.",
	logInAsMultiUser: "Log in to profile",
	attachCurrentToMulti: "Attach user",
	multiUserEmail: "User email address",
	enterUserEmail: "Enter a user email you want to add to this account",
	discardUnsaved: "Discard unsaved changes",
	cancel: "Cancel",
	discard: "Discard",
	attach: "Attach",
	search: "Search",
	noResult: "No Results",
	couldntFind: "We couldn't find {search}.",
	updateSearch: "Please, update your search criteria",
	found: "Found",
	accounts: "accounts",
	attachUser: "Attach user",
	Profile: "Profile",
	"Edit profile": "Edit profile",
	multi_user: {
		emailRequired: "User email address is required.",
		"Access is suspended": "Access is suspended",
		"Select another account": "Select another account",
		"Attach profile": "Attach profile",
		"Sign out": "Sign out",
		"Email to create profile has been sent": "Email to create profile has been sent",
		"User has been successfully attached": "User has been successfully attached",
		"Failed to attach user 1": "Failed to attach user: {msg}",
		Account: "Account",
		"Multi user": "Multi user",
		"Manage account": "Manage account",
		"Launch RWC": "AI Assist",
		"Get support": "Get support",
		"Dark mode": "Dark mode",
		"Switch account": "Switch account",
		"No added another accounts yet": "No added another accounts yet",
		user_item: {
			"MFA required": "You must enable 2FA for profile to access this account.",
			"Set": "Set",
			"Copy account ID": "Copy account ID",
			Copied: "Copied"
		},
		"Account is disabled": "Account is disabled",
		roles: {
			GUEST: "Guest",
			READONLY: "Read-only",
			USER: "User",
			ADMIN: "Admin",
			SUPER_ADMIN: "Super Admin"
		}
	}
};
var DEFAULT_TRANSLATIONS = {
	en: en
};

function useI18n() {
  return {
    initializeI18n() {
      var _a;
      const i18n = (this === null || this === void 0 ? void 0 : this.$i18n) || ((_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy).$i18n;
      i18n.mergeLocaleMessage(i18n.locale, DEFAULT_TRANSLATIONS.en);
    },
    translate(str, values) {
      var _a;
      const i18n = (this === null || this === void 0 ? void 0 : this.$i18n) || ((_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy).$i18n;
      return i18n.t(str, values);
    }
  };
}

const AUTH_API_INJECTION_TOKEN = Symbol('Auth Api injection token');
const ACCOUNTS_API_INJECTION_TOKEN = Symbol('Accounts Api injection token');
const USERS_API_INJECTION_TOKEN = Symbol('Users Api injection token');
const APP_CONFIG = Symbol('App config');

var script$a = defineComponent({
  name: 'ToastNotification',
  components: {
    OrToast: OrToastV3,
    OrTeleport: OrTeleportV3
  },
  props: {
    toastShown: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  setup() {
    const {
      translate
    } = useI18n();
    const toast = ref();
    useElevation(toast);
    const originOverflow = '';
    return {
      originOverflow,
      translate,
      toast
    };
  },
  methods: {
    onBeforeEnter() {
      this.originOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    },
    onAfterLeave() {
      this.originOverflow !== '' ? document.body.style.overflow = 'this.originOverflow' : document.body.style.removeProperty('overflow');
    }
  }
});

const _hoisted_1$9 = {
  key: 0,
  ref: "toast",
  class: "bottom-lg right-lg absolute"
};
function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrToast = resolveComponent("OrToast");
  const _component_OrTeleport = resolveComponent("OrTeleport");
  return openBlock(), createBlock(_component_OrTeleport, null, {
    default: withCtx(() => [createVNode(Transition, {
      name: "or-toast",
      onBeforeEnter: _ctx.onBeforeEnter,
      onAfterLeave: _ctx.onAfterLeave
    }, {
      default: withCtx(() => [_ctx.toastShown ? (openBlock(), createElementBlock("div", _hoisted_1$9, [createVNode(_component_OrToast, {
        "message-text": _ctx.translate('Account ID has been copied.'),
        onClose: _cache[0] || (_cache[0] = $event => _ctx.$emit('close'))
      }, null, 8 /* PROPS */, ["message-text"])], 512 /* NEED_PATCH */)) : createCommentVNode("v-if", true)]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onBeforeEnter", "onAfterLeave"])]),
    _: 1 /* STABLE */
  });
}

var css_248z = ".or-toast-enter-active[data-v-df5e509c],\n.or-toast-leave-active[data-v-df5e509c] {\n  transition: transform 0.4s ease;\n}\n.or-toast-enter[data-v-df5e509c],\n.or-toast-enter-from[data-v-df5e509c],\n.or-toast-leave-to[data-v-df5e509c] {\n  transform: translateX(999px);\n}";
styleInject(css_248z);

script$a.render = render$a;
script$a.__scopeId = "data-v-df5e509c";
script$a.__file = "src/components/ToastNotification.vue";

var script$9 = defineComponent({
  name: 'UserSkeleton',
  components: {
    OrSkeletonCircle: OrSkeletonCircleV3,
    OrSkeletonRect: OrSkeletonRectV3
  }
});

const _hoisted_1$8 = {
  class: "layout-row gap-sm items-center"
};
const _hoisted_2$6 = {
  class: "layout-column gap-none items-start"
};
function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrSkeletonCircle = resolveComponent("OrSkeletonCircle");
  const _component_OrSkeletonRect = resolveComponent("OrSkeletonRect");
  return openBlock(), createElementBlock("div", _hoisted_1$8, [createVNode(_component_OrSkeletonCircle, {
    size: 40
  }), createElementVNode("div", _hoisted_2$6, [createVNode(_component_OrSkeletonRect, {
    width: 74,
    height: 24
  }), createVNode(_component_OrSkeletonRect, {
    width: 131,
    height: 24
  })])]);
}

script$9.render = render$9;
script$9.__file = "src/components/UserSkeleton.vue";

var script$8 = defineComponent({
  name: 'UserItem',
  components: {
    OrTag: OrTagV3,
    OrButton: OrButtonV3,
    OrLoader: OrLoaderV3,
    OrNotification: OrNotificationV3,
    OrAvatar: OrAvatarV3,
    OrText: OrTextV3,
    UserSkeleton: script$9,
    ToastNotification: script$a,
    OrTooltip: OrTooltipV3,
    OrIconButton: OrIconButtonV3
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    disabledInteraction: {
      type: Boolean,
      default: false
    },
    keepLoggedIn: {
      type: Boolean,
      default: false
    },
    copyAccount: {
      type: Boolean,
      default: false
    },
    dummyState: {
      type: Boolean,
      default: false
    }
  },
  emits: ['user-selected'],
  setup() {
    const authApi = inject(AUTH_API_INJECTION_TOKEN);
    const config = inject(APP_CONFIG);
    const {
      translate
    } = useI18n();
    const toastShown = ref(false);
    return {
      getAbbreviation,
      config,
      translate,
      authApi,
      loading: ref(false),
      loginError: ref(null),
      showProfileLink: ref(false),
      toastShown
    };
  },
  computed: {
    userRole() {
      return extractUserRole(this.user);
    }
  },
  methods: {
    selectUser(selected) {
      var _a;
      const call = async () => {
        this.loading = true;
        try {
          return await this.authApi.multiUserLoginUser({
            ...selected,
            long: this.keepLoggedIn
          });
        } catch (e) {
          const response = get(e, 'response.data.message');
          if (response === MfaReqMessage) {
            this.loginError = this.translate('multi_user.user_item.MFA required');
            this.showProfileLink = true;
          } else if (response === AccountDisabledMessage) {
            this.loginError = this.translate('multi_user.Account is disabled');
          } else {
            this.loginError = response || e;
          }
        }
        this.loading = false;
      };
      if (!this.disabledInteraction && !((_a = this.user) === null || _a === void 0 ? void 0 : _a.disabled)) {
        this.$emit('user-selected', call);
      }
    },
    capitalize(str) {
      return startCase(str);
    },
    openProfile() {
      window.open(`${this.config.AUTH_UI_URL}/profile/security`);
    },
    copyAccId() {
      navigator.clipboard.writeText(this.user.accountId);
      this.toastShown = true;
      setTimeout(() => this.toastShown = false, 2000);
    }
  }
});

const _hoisted_1$7 = {
  key: 0
};
const _hoisted_2$5 = {
  key: 0,
  class: "p-[10px]"
};
const _hoisted_3$4 = {
  key: 1
};
const _hoisted_4$2 = {
  key: 0,
  class: "flex items-center overflow-hidden gap-sm w-full"
};
const _hoisted_5$2 = /*#__PURE__*/createElementVNode("div", {
  class: "h-sm w-sm bg-error rounded-full"
}, null, -1 /* HOISTED */);
const _hoisted_6$2 = {
  key: 1,
  class: "layout-row gap-sm max-w-full"
};
function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_UserSkeleton = resolveComponent("UserSkeleton");
  const _component_OrLoader = resolveComponent("OrLoader");
  const _component_OrAvatar = resolveComponent("OrAvatar");
  const _component_OrText = resolveComponent("OrText");
  const _component_OrTooltip = resolveComponent("OrTooltip");
  const _component_OrIconButton = resolveComponent("OrIconButton");
  const _component_OrTag = resolveComponent("OrTag");
  const _component_OrButton = resolveComponent("OrButton");
  const _component_OrNotification = resolveComponent("OrNotification");
  const _component_ToastNotification = resolveComponent("ToastNotification");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["px-lg py-sm", {
      'hover:bg-primary-opacity-0-08': !_ctx.user.disabled && !_ctx.disabledInteraction
    }])
  }, [createCommentVNode(" start dummy block  "), _ctx.dummyState ? (openBlock(), createElementBlock("div", _hoisted_1$7, [createVNode(_component_UserSkeleton)])) : (openBlock(), createElementBlock(Fragment, {
    key: 1
  }, [createCommentVNode(" end dummy block "), createElementVNode("div", null, [createElementVNode("div", {
    class: normalizeClass(["user flex flex-row gap-sm items-center", {
      'cursor-pointer': !_ctx.user.disabled && !_ctx.disabledInteraction
    }]),
    "data-test": "user",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.selectUser(_ctx.user))
  }, [_ctx.loading ? (openBlock(), createElementBlock("div", _hoisted_2$5, [createVNode(_component_OrLoader, {
    type: "circle"
  })])) : (openBlock(), createElementBlock("div", _hoisted_3$4, [createVNode(_component_OrAvatar, {
    size: "m",
    class: normalizeClass({
      '!bg-on-disabled': _ctx.user.disabled
    }),
    "color-salt": _ctx.user.accountId
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.getAbbreviation(_ctx.user.accountName, 2)), 1 /* TEXT */)]),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "color-salt"])])), createElementVNode("div", {
    class: normalizeClass(["flex flex-col items-start overflow-hidden flex-1", {
      'pr-sm': _ctx.copyAccount
    }])
  }, [createVNode(_component_OrTooltip, {
    class: "w-full !justify-start",
    content: _ctx.user.accountName
  }, {
    default: withCtx(() => [createVNode(_component_OrText, {
      class: normalizeClass(["typography-body-2-regular dark:text-on-background-dark", {
        'text-on-disabled': _ctx.user.disabled
      }]),
      text: _ctx.user.accountName
    }, null, 8 /* PROPS */, ["class", "text"])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["content"]), _ctx.user.disabled ? (openBlock(), createElementBlock("div", _hoisted_4$2, [_hoisted_5$2, createVNode(_component_OrText, {
    class: "typography-caption-regular text-outline dark:text-on-background-dark overflow-hidden",
    text: _ctx.translate('multi_user.Access is suspended')
  }, null, 8 /* PROPS */, ["text"])])) : _ctx.copyAccount ? (openBlock(), createElementBlock("div", _hoisted_6$2, [createVNode(_component_OrText, {
    class: "typography-caption-regular text-outline dark:text-outline-dark min-w-0 max-w-full",
    text: _ctx.user.accountId
  }, null, 8 /* PROPS */, ["text"]), createVNode(_component_OrIconButton, {
    tooltip: _ctx.translate('multi_user.user_item.Copy account ID'),
    icon: "content_copy",
    size: "m",
    "data-test": "user-copy-account",
    onClick: _ctx.copyAccId
  }, null, 8 /* PROPS */, ["tooltip", "onClick"])])) : createCommentVNode("v-if", true)], 2 /* CLASS */), createVNode(_component_OrTag, {
    class: normalizeClass(["ml-auto h-lg+", {
      '!text-on-disabled !bg-disabled': _ctx.user.disabled
    }])
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate(`multi_user.roles.${_ctx.userRole}`)), 1 /* TEXT */)]),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"])], 2 /* CLASS */), _ctx.loginError ? (openBlock(), createBlock(_component_OrNotification, {
    key: 0,
    type: "error",
    size: 'inline',
    "can-delete": true,
    onClose: _cache[1] || (_cache[1] = $event => _ctx.loginError = null)
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.loginError) + " ", 1 /* TEXT */), _ctx.showProfileLink ? (openBlock(), createBlock(_component_OrButton, {
      key: 0,
      variant: "link",
      onClick: _ctx.openProfile
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate('multi_user.user_item.Set')), 1 /* TEXT */)]),

      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClick"])) : createCommentVNode("v-if", true)]),
    _: 1 /* STABLE */
  })) : createCommentVNode("v-if", true)])], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)), createVNode(_component_ToastNotification, {
    "toast-shown": _ctx.toastShown,
    onClose: _cache[2] || (_cache[2] = $event => _ctx.toastShown = false)
  }, null, 8 /* PROPS */, ["toast-shown"])], 2 /* CLASS */);
}

script$8.render = render$8;
script$8.__file = "src/components/UserItem.vue";

var script$7 = defineComponent({
  name: 'SwitchAccount',
  components: {
    userItem: script$8,
    OrIconButton: OrIconButtonV3,
    OrInput: OrInputV3
  },
  props: {
    availableUsers: {
      type: Array,
      default: () => []
    },
    userData: {
      type: Object,
      default: () => {}
    },
    keepLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  emits: ['onBackClick', 'user-selected'],
  setup() {
    const {
      translate
    } = useI18n();
    const filter = ref('');
    return {
      filter,
      translate
    };
  },
  computed: {
    items() {
      return (this.availableUsers || []).filter(i => {
        const filterCondition = i.accountName.toLowerCase().includes((this.filter || '').toLowerCase());
        const disabledCondition = i.disabled;
        return filterCondition && !disabledCondition;
      }).sort((a, b) => b.accountName.localeCompare(a.accountName)).sort((a, b) => {
        var _a, _b, _c;
        return isNaN(Number((_a = b.data) === null || _a === void 0 ? void 0 : _a.lastLoginTime)) ? -1 : Number((_b = a.data) === null || _b === void 0 ? void 0 : _b.lastLoginTime) > Number((_c = b.data) === null || _c === void 0 ? void 0 : _c.lastLoginTime) ? -1 : 1;
      });
    }
  },
  methods: {
    onBackClick() {
      this.$emit('onBackClick');
    },
    userSelected(userSwitch) {
      this.$emit('user-selected', userSwitch);
    }
  }
});

const _hoisted_1$6 = {
  class: "flex flex-col pb-sm"
};
const _hoisted_2$4 = {
  class: "flex flex-col px-lg pt-lg"
};
const _hoisted_3$3 = {
  class: "flex flex-row gap-sm items-center dark:text-white"
};
const _hoisted_4$1 = {
  class: "typography-headline-4 dark:text-white"
};
const _hoisted_5$1 = {
  key: 0,
  class: "pt-md"
};
const _hoisted_6$1 = {
  key: 1,
  class: "pt-md typography-caption-regular text-outline dark:text-outline-dark pb-sm"
};
const _hoisted_7$1 = {
  class: "typography-caption-bold"
};
const _hoisted_8$1 = {
  key: 1
};
const _hoisted_9$1 = {
  key: 0,
  class: "flex justify-center typography-headline-4 dark:text-white my-4xl md:m-auto"
};
const _hoisted_10$1 = {
  key: 1,
  class: "mt-2xl md:m-auto flex flex-col items-center"
};
const _hoisted_11$1 = {
  class: "typography-headline-4 dark:text-white"
};
const _hoisted_12 = {
  class: "typography-caption-regular text-outline dark:text-outline-dark"
};
const _hoisted_13 = {
  class: "typography-caption-regular text-outline dark:text-outline-dark"
};
const _hoisted_14 = {
  key: 2,
  class: "overflow-auto"
};
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIconButton = resolveComponent("OrIconButton");
  const _component_OrInput = resolveComponent("OrInput");
  const _component_user_item = resolveComponent("user-item");
  return openBlock(), createElementBlock("div", _hoisted_1$6, [createElementVNode("div", _hoisted_2$4, [createElementVNode("div", _hoisted_3$3, [createVNode(_component_OrIconButton, {
    icon: "arrow_back",
    onClick: _ctx.onBackClick
  }, null, 8 /* PROPS */, ["onClick"]), createElementVNode("span", _hoisted_4$1, toDisplayString(_ctx.translate('multi_user.Switch account')), 1 /* TEXT */)]), _ctx.availableUsers.length > 7 ? (openBlock(), createElementBlock("div", _hoisted_5$1, [createVNode(_component_OrInput, {
    modelValue: _ctx.filter,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.filter = $event),
    class: "w-full",
    type: "search",
    placeholder: "Search"
  }, null, 8 /* PROPS */, ["modelValue"])])) : createCommentVNode("v-if", true), _ctx.items.length ? (openBlock(), createElementBlock("div", _hoisted_6$1, [_ctx.filter && _ctx.filter.length ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createElementVNode("span", null, toDisplayString(_ctx.translate('found')), 1 /* TEXT */), createElementVNode("span", _hoisted_7$1, toDisplayString(' ' + _ctx.items.length + ' '), 1 /* TEXT */), createElementVNode("span", null, toDisplayString(_ctx.translate('accounts')), 1 /* TEXT */)], 64 /* STABLE_FRAGMENT */)) : (openBlock(), createElementBlock("span", _hoisted_8$1, toDisplayString(_ctx.translate('multi_user.Select another account')), 1 /* TEXT */))])) : createCommentVNode("v-if", true)]), !_ctx.availableUsers.length ? (openBlock(), createElementBlock("div", _hoisted_9$1, toDisplayString(_ctx.translate('multi_user.No added another accounts yet')), 1 /* TEXT */)) : _ctx.availableUsers.length && !_ctx.items.length ? (openBlock(), createElementBlock("div", _hoisted_10$1, [createElementVNode("div", _hoisted_11$1, toDisplayString(_ctx.translate('noResult')), 1 /* TEXT */), createElementVNode("div", _hoisted_12, toDisplayString(_ctx.translate('couldntFind', {
    search: _ctx.filter
  })), 1 /* TEXT */), createElementVNode("div", _hoisted_13, toDisplayString(_ctx.translate('updateSearch')), 1 /* TEXT */)])) : (openBlock(), createElementBlock("div", _hoisted_14, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, user => {
    return openBlock(), createBlock(_component_user_item, {
      key: user.id,
      user: user,
      "keep-logged-in": _ctx.keepLoggedIn,
      onUserSelected: _ctx.userSelected
    }, null, 8 /* PROPS */, ["user", "keep-logged-in", "onUserSelected"]);
  }), 128 /* KEYED_FRAGMENT */))]))]);
}

script$7.render = render$7;
script$7.__file = "src/components/SwitchAccount.vue";

var script$6 = defineComponent({
  name: 'ProfileIconBtn',
  components: {
    OrIconV3,
    OrButtonV3
  },
  props: {
    pressed: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  expose: ['root'],
  setup() {
    const root = ref();
    const {
      isMobile
    } = useResponsive();
    return {
      isMobile,
      root
    };
  }
});

function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIconV3 = resolveComponent("OrIconV3");
  const _component_OrButtonV3 = resolveComponent("OrButtonV3");
  return openBlock(), createBlock(_component_OrButtonV3, {
    ref: "root",
    size: "small",
    color: "inherit",
    type: "button",
    class: normalizeClass(["!min-w-0 !gap-xs bg-black !p-xs text-white !shadow-none hover:bg-inverse-surface", {
      '!bg-white !text-black': _ctx.pressed
    }]),
    "data-test": "auth-popover-trigger",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click', $event))
  }, {
    default: withCtx(() => [createVNode(_component_OrIconV3, {
      size: _ctx.isMobile ? 'm' : 'xl',
      variant: "filled",
      icon: "account_circle"
    }, null, 8 /* PROPS */, ["size"]), createVNode(_component_OrIconV3, {
      icon: _ctx.pressed ? 'expand_less' : 'expand_more',
      color: "inherit"
    }, null, 8 /* PROPS */, ["icon"])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"]);
}

script$6.render = render$6;
script$6.__file = "src/components/ProfileIconBtn.vue";

var script$5 = defineComponent({
  name: 'ModalAttach',
  components: {
    OrModal: OrModalV3,
    OrInput: OrInputV3,
    OrButton: OrButtonV3,
    OrNotification: OrNotificationV3
  },
  props: {
    trigger: {
      type: HTMLElement,
      required: false,
      default: null
    },
    attachLoading: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: null,
      required: false
    },
    attachResponse: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['close', 'attach', 'dismiss-error'],
  setup() {
    const {
      translate
    } = useI18n();
    const attachEmail = ref('');
    const beforeAttachMulti = true;
    const beforeAttachMultiSecond = true;
    const showError = ref(false);
    return {
      attachEmail,
      showError,
      translate,
      beforeAttachMulti,
      beforeAttachMultiSecond
    };
  },
  watch: {
    attachEmail(value) {
      this.attachEmail = value;
      this.showError = !(value === null || value === void 0 ? void 0 : value.length);
    }
  },
  methods: {
    submit() {
      if (isEmpty(this.attachEmail)) {
        this.showError = true;
      } else {
        this.$emit('attach', this.attachEmail);
      }
    }
  }
});

const _hoisted_1$5 = {
  key: 0,
  "data-test": "response-error",
  class: "flex flex-col pb-lg gap-sm"
};
const _hoisted_2$3 = {
  class: "pb-md"
};
const _hoisted_3$2 = {
  class: "flex items-center flex-row-reverse gap-md"
};
function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrNotification = resolveComponent("OrNotification");
  const _component_OrInput = resolveComponent("OrInput");
  const _component_OrButton = resolveComponent("OrButton");
  const _component_OrModal = resolveComponent("OrModal");
  return openBlock(), createBlock(_component_OrModal, {
    "is-open": true,
    size: "s",
    onClose: _cache[3] || (_cache[3] = $event => _ctx.$emit('close'))
  }, {
    header: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate('attachCurrentToMulti')), 1 /* TEXT */)]),

    footer: withCtx(() => [createElementVNode("div", _hoisted_3$2, [createVNode(_component_OrButton, {
      "data-test": "attach-button",
      class: "w-[128px]",
      disabled: _ctx.attachLoading,
      onClick: _ctx.submit
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate('attach')), 1 /* TEXT */)]),

      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["disabled", "onClick"]), createVNode(_component_OrButton, {
      "data-test": "cancel-button",
      class: "w-[128px]",
      variant: "outlined",
      loading: _ctx.attachLoading,
      onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('close'))
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate('cancel')), 1 /* TEXT */)]),

      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["loading"])])]),
    default: withCtx(() => [_ctx.attachResponse ? (openBlock(), createElementBlock("div", _hoisted_1$5, [createVNode(_component_OrNotification, {
      variant: "error",
      onClose: _cache[0] || (_cache[0] = $event => _ctx.$emit('dismiss-error'))
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.attachResponse.message), 1 /* TEXT */)]),

      _: 1 /* STABLE */
    })])) : createCommentVNode("v-if", true), createElementVNode("div", _hoisted_2$3, toDisplayString(_ctx.translate('enterUserEmail')), 1 /* TEXT */), createVNode(_component_OrInput, {
      modelValue: _ctx.attachEmail,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.attachEmail = $event),
      type: "text",
      label: _ctx.translate('multiUserEmail'),
      placeholder: _ctx.translate('Enter user email address'),
      error: _ctx.showError ? _ctx.translate('multi_user.emailRequired') : null
    }, null, 8 /* PROPS */, ["modelValue", "label", "placeholder", "error"])]),
    _: 1 /* STABLE */
  });
}

script$5.render = render$5;
script$5.__file = "src/components/ModalAttach.vue";

var script$4 = defineComponent({
  name: 'ProfileSkeleton',
  components: {
    OrSkeletonCircle: OrSkeletonCircleV3,
    OrSkeletonRect: OrSkeletonRectV3
  }
});

const _hoisted_1$4 = {
  class: "layout-column gap-sm items-center"
};
const _hoisted_2$2 = {
  class: "layout-column gap-none items-center"
};
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrSkeletonCircle = resolveComponent("OrSkeletonCircle");
  const _component_OrSkeletonRect = resolveComponent("OrSkeletonRect");
  return openBlock(), createElementBlock("div", _hoisted_1$4, [createVNode(_component_OrSkeletonCircle, {
    size: 64
  }), createElementVNode("div", _hoisted_2$2, [createVNode(_component_OrSkeletonRect, {
    width: 140,
    height: 24
  }), createVNode(_component_OrSkeletonRect, {
    width: 197,
    height: 18
  })])]);
}

script$4.render = render$4;
script$4.__file = "src/components/ProfileSkeleton.vue";

var script$3 = defineComponent({
  name: 'DeviderLine'
});

const _hoisted_1$3 = {
  class: "py-sm w-full"
};
const _hoisted_2$1 = /*#__PURE__*/createElementVNode("div", {
  class: "h-[1px] bg-outline-variant dark:bg-outline-variant-dark"
}, null, -1 /* HOISTED */);
const _hoisted_3$1 = [_hoisted_2$1];
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$3, _hoisted_3$1);
}

script$3.render = render$3;
script$3.__file = "src/components/DeviderLine.vue";

var profileIcon = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDBweCIgaGVpZ2h0PSI0MHB4IiB2aWV3Qm94PSIwIDAgNDAgNDAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+VXNlciBpY29uPC90aXRsZT4KICAgIDxnIGlkPSJTaWduLWluIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTXVsdGlwbGUtQWNjb3VudHMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTEyLjAwMDAwMCwgLTI1MC4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9IlNlbGVjdC9NdWx0aXNlbGVjdC1OZXciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwODguMDAwMDAwLCAzMi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJBY2NvdW50cyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDE4NC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iQWNjb3VudC1uYW1lIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNC4wMDAwMDAsIDM0LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iVXNlci1pY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGZpbGw9IiNGNkY2RjYiIGN4PSIyMCIgY3k9IjIwIiByPSIyMCI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBmaWxsPSIjQzZDNkM2IiBjeD0iMjAiIGN5PSIxMy41IiByPSI2LjUiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTIwLDIyIEMyNi4zMDc4MDkyLDIyIDMxLjcwNjIzOTcsMjUuODkzNTEyOSAzMy45MjMxMTIzLDMxLjQwODM1OTUgQzMwLjYyMjI0NjEsMzUuNDMyNzE4NCAyNS42MTA5MzM0LDM4IDIwLDM4IEMxNC4zODkwNjY2LDM4IDkuMzc3NzUzOTEsMzUuNDMyNzE4NCA2LjA3NjY0MTg4LDMxLjQwODczNSBDOC4yOTM3NjAzMiwyNS44OTM1MTI5IDEzLjY5MjE5MDgsMjIgMjAsMjIgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIiBmaWxsPSIjQzZDNkM2Ij48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==';

const menuItemsStyles = ['!layout-column', '!items-start', '!px-md', '-mx-md', 'md:py-sm', 'py-md', '!typography-body-2-regular', '!text-black', 'dark:!text-white'];

var script$2 = defineComponent({
  name: 'ProfileContent',
  components: {
    UserItem: script$8,
    ProfileSkeleton: script$4,
    DeviderLine: script$3,
    OrMenuItemV3,
    OrLoaderV3,
    OrSwitchV3,
    OrAvatarV3,
    OrTooltipV3,
    OrTextV3,
    OrIconButtonV3
  },
  props: {
    token: {
      type: String,
      default: null
    },
    darkModeOptions: {
      type: Object,
      default: () => {}
    },
    userData: {
      type: Object,
      default: () => {}
    },
    multiUser: {
      type: Object,
      default: () => {}
    },
    signingOutLoader: {
      type: Boolean,
      default: false
    },
    hasMultiCookies: {
      type: Boolean,
      default: false
    },
    profileDummyState: {
      type: Boolean,
      default: true
    },
    currentUserDummyState: {
      type: Boolean,
      default: true
    }
  },
  emits: ['userAttachStart', 'signOut', 'switchAccount'],
  setup(props) {
    const userProfile = ref();
    const config = inject(APP_CONFIG);
    const {
      isDark
    } = useDarkMode(config, props.darkModeOptions);
    const {
      translate
    } = useI18n();
    function handleProfileEdit() {
      window.open(`${config.AUTH_UI_URL}/profile`, '_blank');
    }
    return {
      userProfile,
      profileIcon,
      isDark,
      config,
      translate,
      menuItemsStyles,
      handleProfileEdit
    };
  },
  computed: {
    height() {
      var _a, _b;
      return (_b = (_a = this.userProfile) === null || _a === void 0 ? void 0 : _a.scrollHeight) !== null && _b !== void 0 ? _b : 0;
    },
    getDarkModeHotkey() {
      return navigator.platform === 'MacIntel' ? '⇧⌘D' : 'Ctrl + Shift + D';
    },
    multiUserIcon() {
      return get(this.multiUser, 'data.profile.icon', profileIcon);
    },
    showMenu() {
      return this.hasMultiCookies || this.enableProblemHelper || this.showAttachProfile;
    },
    multiUserFL() {
      return `${get(this.multiUser, 'data.profile.firstName', '')} ${get(this.multiUser, 'data.profile.lastName', '')}`.trim();
    },
    multiUserAbr() {
      return getAbbreviation(this.multiUserFL, 2);
    },
    showAttachProfile() {
      var _a;
      return !this.userData.multiUserId && ((_a = this.config) === null || _a === void 0 ? void 0 : _a.MULTI_USERS_ENABLED) === true;
    },
    enableProblemHelper() {
      var _a, _b;
      if (endsWith(this.userData.username, 'onereach.ai') || endsWith(this.userData.username, 'onereach.com')) {
        return !!((_b = (_a = this.config.UTILS_MENU_LIST) === null || _a === void 0 ? void 0 : _a.TICKET_CHAT_UI_URL) === null || _b === void 0 ? void 0 : _b.length);
      }
      return false;
    },
    MULTI_USERS_ENABLED() {
      var _a;
      return (_a = this.config) === null || _a === void 0 ? void 0 : _a.MULTI_USERS_ENABLED;
    },
    multiUserUsername() {
      return get(this.multiUser, 'username', '');
    }
  },
  methods: {
    switchAccount() {
      this.$emit('switchAccount');
    },
    logOut() {
      this.$emit('signOut');
    },
    onAttachClick() {
      this.$emit('userAttachStart');
    },
    openProblemHelper() {
      Chat.launchChatBotWindow({
        token: this.token,
        contextType: 'service-navigation',
        targetFlowName: '',
        title: '',
        chatUrl: this.config.UTILS_MENU_LIST.TICKET_CHAT_UI_URL,
        serviceDiscoveryUrl: this.config.UTILS_MENU_LIST.SERVICE_DISCOVERY_API_URL
      }, {
        parentServiceUrl: window.location.href
      });
    }
  }
});

const _hoisted_1$2 = {
  ref: "userProfile",
  class: "p-md"
};
const _hoisted_2 = {
  key: 0,
  class: "pb-sm"
};
const _hoisted_3 = {
  key: 1,
  class: "layout-column items-center gap-sm pb-sm"
};
const _hoisted_4 = {
  class: "layout-row w-full justify-between"
};
const _hoisted_5 = {
  class: "typography-caption-regular text-outline dark:text-outline-dark"
};
const _hoisted_6 = {
  class: "flex flex-col items-center max-w-full"
};
const _hoisted_7 = {
  class: "layout-column py-sm"
};
const _hoisted_8 = {
  key: 2
};
const _hoisted_9 = ["href"];
const _hoisted_10 = {
  class: "layout-row justify-between"
};
const _hoisted_11 = {
  class: "typography-caption-regular text-on-disabled dark:text-on-disabled-dark"
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProfileSkeleton = resolveComponent("ProfileSkeleton");
  const _component_OrIconButtonV3 = resolveComponent("OrIconButtonV3");
  const _component_OrAvatarV3 = resolveComponent("OrAvatarV3");
  const _component_OrTextV3 = resolveComponent("OrTextV3");
  const _component_OrTooltipV3 = resolveComponent("OrTooltipV3");
  const _component_DeviderLine = resolveComponent("DeviderLine");
  const _component_UserItem = resolveComponent("UserItem");
  const _component_OrMenuItemV3 = resolveComponent("OrMenuItemV3");
  const _component_OrSwitchV3 = resolveComponent("OrSwitchV3");
  const _component_OrLoaderV3 = resolveComponent("OrLoaderV3");
  return openBlock(), createElementBlock("div", _hoisted_1$2, [_ctx.hasMultiCookies ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [_ctx.profileDummyState ? (openBlock(), createElementBlock("div", _hoisted_2, [createVNode(_component_ProfileSkeleton)])) : (openBlock(), createElementBlock("div", _hoisted_3, [createElementVNode("div", _hoisted_4, [createElementVNode("span", _hoisted_5, toDisplayString(_ctx.translate('Profile')), 1 /* TEXT */), createVNode(_component_OrIconButtonV3, {
    icon: {
      icon: 'edit'
    },
    size: "m",
    tooltip: _ctx.translate('Edit profile'),
    onClick: _ctx.handleProfileEdit
  }, null, 8 /* PROPS */, ["tooltip", "onClick"])]), createVNode(_component_OrAvatarV3, {
    src: _ctx.multiUserIcon,
    size: "l"
  }, {
    default: withCtx(() => [!_ctx.multiUserIcon && _ctx.multiUserAbr ? (openBlock(), createElementBlock(Fragment, {
      key: 0
    }, [createTextVNode(toDisplayString(_ctx.multiUserAbr), 1 /* TEXT */)], 64 /* STABLE_FRAGMENT */)) : createCommentVNode("v-if", true)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["src"]), createElementVNode("div", _hoisted_6, [createVNode(_component_OrTooltipV3, {
    content: _ctx.multiUserFL
  }, {
    default: withCtx(() => [createVNode(_component_OrTextV3, {
      class: "typography-body-2-bold dark:text-white",
      text: _ctx.multiUserFL
    }, null, 8 /* PROPS */, ["text"])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["content"]), createVNode(_component_OrTooltipV3, {
    content: _ctx.multiUserUsername
  }, {
    default: withCtx(() => [createVNode(_component_OrTextV3, {
      class: "typography-caption-regular text-outline dark:text-outline-dark",
      text: _ctx.multiUserUsername
    }, null, 8 /* PROPS */, ["text"])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["content"])])]))], 64 /* STABLE_FRAGMENT */)) : createCommentVNode("v-if", true), _ctx.hasMultiCookies ? (openBlock(), createBlock(_component_DeviderLine, {
    key: 1
  })) : createCommentVNode("v-if", true), createElementVNode("div", _hoisted_7, [createElementVNode("div", {
    class: normalizeClass(["typography-caption-regular text-outline dark:text-outline-dark", {
      'h-md w-3/12 bg-surface-2 rounded-md ml-lg': _ctx.currentUserDummyState
    }])
  }, toDisplayString(_ctx.currentUserDummyState ? '' : _ctx.translate('multi_user.Account')), 3 /* TEXT, CLASS */), createVNode(_component_UserItem, {
    class: "!px-[0]",
    "dummy-state": _ctx.currentUserDummyState,
    "disabled-interaction": true,
    user: _ctx.userData,
    "copy-account": true
  }, null, 8 /* PROPS */, ["dummy-state", "user"])]), _ctx.showMenu ? (openBlock(), createElementBlock("div", _hoisted_8, [_ctx.hasMultiCookies ? (openBlock(), createBlock(_component_OrMenuItemV3, {
    key: 0,
    class: normalizeClass(_ctx.menuItemsStyles)
  }, {
    default: withCtx(() => [createElementVNode("a", {
      class: "block w-full",
      href: `${_ctx.config.AUTH_UI_URL}/account`,
      target: "_blank"
    }, toDisplayString(_ctx.translate('multi_user.Manage account')), 9 /* TEXT, PROPS */, _hoisted_9)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"])) : createCommentVNode("v-if", true), _ctx.hasMultiCookies ? (openBlock(), createBlock(_component_OrMenuItemV3, {
    key: 1,
    class: normalizeClass(_ctx.menuItemsStyles),
    "data-test": "switch-account",
    onClick: _ctx.switchAccount
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate('multi_user.Switch account')), 1 /* TEXT */)]),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "onClick"])) : createCommentVNode("v-if", true), !_ctx.userData.multiUserId && _ctx.MULTI_USERS_ENABLED ? (openBlock(), createBlock(_component_OrMenuItemV3, {
    key: 2,
    class: normalizeClass(_ctx.menuItemsStyles),
    onClick: _ctx.onAttachClick
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate('multi_user.Attach profile')), 1 /* TEXT */)]),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "onClick"])) : createCommentVNode("v-if", true), createVNode(_component_DeviderLine), _ctx.enableProblemHelper ? (openBlock(), createBlock(_component_OrMenuItemV3, {
    key: 3,
    "data-test": "problem-helper",
    class: normalizeClass(_ctx.menuItemsStyles),
    onClick: _ctx.openProblemHelper
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate('multi_user.Get support')), 1 /* TEXT */)]),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "onClick"])) : createCommentVNode("v-if", true)])) : createCommentVNode("v-if", true), createVNode(_component_OrMenuItemV3, {
    class: normalizeClass(_ctx.menuItemsStyles)
  }, {
    default: withCtx(() => [createElementVNode("div", _hoisted_10, [createVNode(_component_OrSwitchV3, {
      modelValue: _ctx.isDark,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.isDark = $event),
      label: _ctx.translate('multi_user.Dark mode')
    }, null, 8 /* PROPS */, ["modelValue", "label"]), createElementVNode("span", _hoisted_11, toDisplayString(_ctx.getDarkModeHotkey), 1 /* TEXT */)])]),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"]), createVNode(_component_DeviderLine), createVNode(_component_OrMenuItemV3, {
    "data-test": "log-out",
    class: normalizeClass(_ctx.menuItemsStyles),
    onClick: _cache[1] || (_cache[1] = $event => _ctx.logOut())
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate('multi_user.Sign out')) + " ", 1 /* TEXT */), _ctx.signingOutLoader ? (openBlock(), createBlock(_component_OrLoaderV3, {
      key: 0,
      type: "circle"
    })) : createCommentVNode("v-if", true)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"])], 512 /* NEED_PATCH */);
}

script$2.render = render$2;
script$2.__file = "src/components/ProfileContent.vue";

var script$1 = defineComponent({
  name: 'NotificationContainer',
  components: {
    OrTeleport: OrTeleportV3
  },
  emits: ['close'],
  setup() {
    const notificationContainer = ref();
    useElevation(notificationContainer);
    return {
      notificationContainer
    };
  }
});

const _hoisted_1$1 = {
  ref: "notificationContainer",
  class: "flex w-full justify-center absolute p-xs"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrTeleport = resolveComponent("OrTeleport");
  return openBlock(), createBlock(_component_OrTeleport, {
    to: "header"
  }, {
    default: withCtx(() => [createElementVNode("div", _hoisted_1$1, [renderSlot(_ctx.$slots, "default")], 512 /* NEED_PATCH */)]),

    _: 3 /* FORWARDED */
  });
}

script$1.render = render$1;
script$1.__file = "src/components/NotificationContainer.vue";

const cookies = new Cookies();
// @ts-ignore
var script = defineComponent({
  name: 'AuthPopover',
  components: {
    OrPopover: OrPopoverV3,
    SwitchAccount: script$7,
    ProfileIconBtn: script$6,
    OrConfirm: OrConfirmV3,
    ModalAttach: script$5,
    ProfileContent: script$2,
    NotificationContainer: script$1,
    OrNotification: OrNotificationV3
  },
  props: {
    token: {
      type: String,
      default: null
    },
    redirectPathOnAccountSwitch: {
      type: String,
      default: '/'
    },
    darkModeOptions: {
      type: Object,
      default: () => {}
    },
    hasUnsavedChanges: {
      type: Boolean,
      default: false
    }
  },
  emits: ['confirm', 'userSuspended'],
  setup(props) {
    const usersApi = inject(USERS_API_INJECTION_TOKEN);
    const config = inject(APP_CONFIG);
    const authApi = inject(AUTH_API_INJECTION_TOKEN);
    const accountsApi = inject(ACCOUNTS_API_INJECTION_TOKEN);
    const {
      isDesktop
    } = useResponsive();
    useDarkMode(config, props.darkModeOptions);
    const profileMenuButton = ref();
    const popover = ref();
    const profileContent = ref();
    const container = ref(null);
    const {
      translate,
      initializeI18n
    } = useI18n();
    const isOpen = ref(false);
    const userData = authApi._getUser;
    const userProfile = ref(null);
    const keepLoggedIn = +cookies.get(authApi.userExpireCookieName) === +authApi.expireInLong;
    const currentTab = ref(ProfileMenuTab.profile);
    const availableUsers = ref([]);
    const notificationShown = ref(false);
    const profileDummyState = ref(true);
    const accountDummyState = ref(true);
    const popoverYRect = ref(0);
    // Effects
    onBeforeMount(() => {
      initializeI18n();
    });
    return {
      availableUsers,
      usersApi,
      authApi,
      accountsApi,
      isOpen,
      profileMenuButton,
      popover,
      profileContent,
      container,
      hasMultiCookies: ref(false),
      userData,
      userProfile,
      config,
      keepLoggedIn,
      isLoggingIn: ref(false),
      attachLoading: ref(false),
      attachResponse: ref(null),
      isConfirmModalOpen: ref(false),
      isAttachModalOpen: ref(false),
      translate,
      currentTab,
      confirm: ref(noop),
      deny: ref(noop),
      signingOutLoader: ref(false),
      fixedSwitchAccountHeight: ref({}),
      isDesktop,
      notificationShown,
      profileDummyState,
      accountDummyState,
      popoverYRect
    };
  },
  computed: {
    tokenExist() {
      var _a;
      return !!((_a = this.token) === null || _a === void 0 ? void 0 : _a.length);
    }
  },
  watch: {
    token: {
      handler: async function (val) {
        if (val) {
          await Promise.all([this.getUserGetProfile(), this.getAccountData(), this.getUserList()]);
        }
      },
      immediate: true
    }
  },
  methods: {
    onPopoverStateUpdate(event) {
      this.isOpen = event === 'open';
      if (!this.isOpen) {
        this.currentTab = ProfileMenuTab.profile;
      }
      if (!this.popoverYRect) {
        //need to wait a bit until the component is not rendered "at place",
        setTimeout(() => {
          var _a, _b;
          this.popoverYRect = ((_b = (_a = this.container) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.y) || 0;
        }, 10);
      }
    },
    onClick() {
      var _a;
      (_a = this.popover) === null || _a === void 0 ? void 0 : _a[this.isOpen ? 'close' : 'open']();
    },
    async getUserList() {
      var _a, _b, _c;
      const userList = await this.authApi.multiUserGetUsersList().catch(() => []);
      this.availableUsers = sortBy(reject(userList, {
        id: (_a = this.userData) === null || _a === void 0 ? void 0 : _a.userId
      }), account => account.accountName.toLowerCase());
      const user = find(userList, {
        id: (_b = this.userData) === null || _b === void 0 ? void 0 : _b.userId
      });
      this.userData = {
        ...this.userData,
        data: {
          ...this.userData.data,
          permissions: (_c = user === null || user === void 0 ? void 0 : user.data) === null || _c === void 0 ? void 0 : _c.permissions
        }
      };
    },
    async getUserGetProfile() {
      try {
        await this.authApi.validateMultiUserToken();
        this.hasMultiCookies = true;
        this.profileDummyState = false;
        this.userProfile = await this.authApi.multiUserGetProfile();
      } catch (e) {
        // no mult cookies
      }
    },
    async getAccountData() {
      var _a, _b;
      const callback = res => {
        this.userData = {
          ...this.userData,
          accountName: res.accountName
        };
        this.accountDummyState = false;
      };
      (_a = this.accountsApi) === null || _a === void 0 ? void 0 : _a.getAccountData((_b = this.userData) === null || _b === void 0 ? void 0 : _b.accountId).then(callback).catch(async error => {
        var _a, _b, _c, _d;
        if (((_c = (_b = (_a = error.cause) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message.includes('suspended')) || error.message.includes('suspended')) {
          const isValid = await ((_d = this.usersApi) === null || _d === void 0 ? void 0 : _d.getAccountInfo().then(res => {
            callback(res);
            if (window.location.origin !== this.config.AUTH_UI_URL) {
              window.location.href = `${this.config.AUTH_UI_URL}/account/payments`;
            } else {
              this.$emit('userSuspended');
            }
            return true;
          }).catch(() => false));
          if (isValid) return;
        }
        console.warn(error);
      });
    },
    onSwitchAccountBackClick() {
      this.currentTab = ProfileMenuTab.profile;
    },
    switchAccount() {
      var _a, _b;
      const height = (_b = (_a = this.profileContent) === null || _a === void 0 ? void 0 : _a.height) !== null && _b !== void 0 ? _b : 0;
      this.fixedSwitchAccountHeight = this.isDesktop ? {
        maxHeight: `${height}px`,
        height: `calc(100vh - ${this.popoverYRect + 10}px)`
      } : {
        height: '100%',
        minHeight: '0'
      };
      this.currentTab = ProfileMenuTab.switchAccount;
    },
    onUserAttachStart() {
      var _a;
      (_a = this.popover) === null || _a === void 0 ? void 0 : _a.close();
      this.notificationShown = false;
      this.isAttachModalOpen = true;
      this.attachResponse = null;
    },
    signOut() {
      var _a;
      if (this.hasUnsavedChanges) {
        this.isLoggingIn = false;
        (_a = this.popover) === null || _a === void 0 ? void 0 : _a.close();
        this.openConfirmModal(() => {
          this.$emit('confirm');
          this.signingOutLoader = false;
          window.location.href = `${this.config.AUTH_UI_URL}/logout?redirectPath=${encodeURIComponent(window.location.origin)}`;
        });
      } else {
        window.location.href = `${this.config.AUTH_UI_URL}/logout?redirectPath=${encodeURIComponent(window.location.origin)}`;
      }
    },
    async attachSubmit(email) {
      var _a;
      this.attachLoading = true;
      try {
        const result = await ((_a = this.usersApi) === null || _a === void 0 ? void 0 : _a.attachProfile({
          email
        }));
        this.attachResponse = {
          showReloginLink: result === null || result === void 0 ? void 0 : result.userAttached,
          status: (result === null || result === void 0 ? void 0 : result.emailSent) ? 'info' : 'success',
          message: (result === null || result === void 0 ? void 0 : result.emailSent) ? this.translate('multi_user.Email to create profile has been sent') : this.translate('multi_user.User has been successfully attached')
        };
        this.notificationShown = true;
        this.isAttachModalOpen = false;
      } catch (e) {
        this.attachResponse = {
          status: 'error',
          message: this.translate('multi_user.Failed to attach user 1', {
            'msg': get(e, 'errorResponse.message', e.message)
          })
        };
      }
      this.attachLoading = false;
    },
    onUserSelect(userSwitch) {
      const call = async () => {
        const res = await userSwitch();
        if (res) window.location.href = this.redirectPathOnAccountSwitch;
      };
      if (this.hasUnsavedChanges) {
        this.openConfirmModal(() => {
          call();
          this.isConfirmModalOpen = false;
        });
      } else {
        call();
      }
    },
    closeAttachModal() {
      this.isAttachModalOpen = false;
    },
    openConfirmModal(onConfirm, onDeny) {
      const defaultClose = () => this.isConfirmModalOpen = false;
      this.deny = onDeny || defaultClose;
      this.confirm = onConfirm || (() => {
        this.$emit('confirm');
        defaultClose();
      });
      this.isConfirmModalOpen = true;
    }
  }
});

const _hoisted_1 = {
  id: "ap-container"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProfileIconBtn = resolveComponent("ProfileIconBtn");
  const _component_profile_content = resolveComponent("profile-content");
  const _component_switch_account = resolveComponent("switch-account");
  const _component_OrPopover = resolveComponent("OrPopover");
  const _component_OrConfirm = resolveComponent("OrConfirm");
  const _component_ModalAttach = resolveComponent("ModalAttach");
  const _component_OrNotification = resolveComponent("OrNotification");
  const _component_NotificationContainer = resolveComponent("NotificationContainer");
  return openBlock(), createElementBlock("div", _hoisted_1, [createVNode(_component_ProfileIconBtn, {
    ref: "profileMenuButton",
    pressed: _ctx.isOpen,
    onClick: _ctx.onClick
  }, null, 8 /* PROPS */, ["pressed", "onClick"]), createVNode(_component_OrPopover, {
    id: "or-popover-menu",
    ref: "popover",
    trigger: _ctx.profileMenuButton ? _ctx.profileMenuButton.root : undefined,
    placement: "bottom-end",
    "onUpdate:state": _ctx.onPopoverStateUpdate
  }, {
    default: withCtx(() => [_ctx.tokenExist ? (openBlock(), createElementBlock("div", {
      key: 0,
      ref: "container",
      style: normalizeStyle({
        ...(_ctx.isDesktop && {
          overflow: _ctx.currentTab === 'profile' ? 'auto' : 'hidden',
          maxHeight: `calc(100vh - ${_ctx.popoverYRect + 10}px)`
        })
      }),
      class: "layout-column w-full md:w-[320px] h-full min-h-[0]"
    }, [withDirectives(createVNode(_component_profile_content, {
      ref: "profileContent",
      "data-test": "profileTab",
      "user-data": _ctx.userData,
      "multi-user": _ctx.userProfile,
      token: _ctx.token,
      "dark-mode-options": _ctx.darkModeOptions,
      "signing-out-loader": _ctx.signingOutLoader,
      "has-multi-cookies": _ctx.hasMultiCookies,
      "current-user-dummy-state": _ctx.accountDummyState,
      "profile-dummy-state": _ctx.profileDummyState,
      onSignOut: _ctx.signOut,
      onSwitchAccount: _ctx.switchAccount,
      onUserAttachStart: _ctx.onUserAttachStart
    }, null, 8 /* PROPS */, ["user-data", "multi-user", "token", "dark-mode-options", "signing-out-loader", "has-multi-cookies", "current-user-dummy-state", "profile-dummy-state", "onSignOut", "onSwitchAccount", "onUserAttachStart"]), [[vShow, _ctx.currentTab === 'profile']]), withDirectives(createVNode(_component_switch_account, {
      "data-test": "switchAccountTab",
      style: normalizeStyle(_ctx.fixedSwitchAccountHeight),
      "user-data": _ctx.userData,
      "available-users": _ctx.availableUsers,
      "keep-logged-in": _ctx.keepLoggedIn,
      onUserSelected: _ctx.onUserSelect,
      onOnBackClick: _ctx.onSwitchAccountBackClick
    }, null, 8 /* PROPS */, ["style", "user-data", "available-users", "keep-logged-in", "onUserSelected", "onOnBackClick"]), [[vShow, _ctx.currentTab === 'switchAccount']])], 4 /* STYLE */)) : createCommentVNode("v-if", true)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger", "onUpdate:state"]), createVNode(_component_OrConfirm, {
    "is-open": _ctx.isConfirmModalOpen,
    "title-text": "Discard unsaved changes",
    "confirm-button-text": "Discard",
    "cancel-button-text": "Keep",
    "confirm-type": "d",
    onClose: _ctx.deny,
    onConfirm: _ctx.confirm
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate('youHaveUnsaved')), 1 /* TEXT */)]),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-open", "onClose", "onConfirm"]), _ctx.isAttachModalOpen ? (openBlock(), createBlock(_component_ModalAttach, {
    key: 0,
    "attach-loading": _ctx.attachLoading,
    "attach-response": _ctx.attachResponse,
    onDismissError: _cache[0] || (_cache[0] = $event => _ctx.attachResponse = null),
    onAttach: _ctx.attachSubmit,
    onClose: _ctx.closeAttachModal
  }, null, 8 /* PROPS */, ["attach-loading", "attach-response", "onAttach", "onClose"])) : createCommentVNode("v-if", true), _ctx.notificationShown ? (openBlock(), createBlock(_component_NotificationContainer, {
    key: 1
  }, {
    default: withCtx(() => [createVNode(_component_OrNotification, {
      variant: _ctx.attachResponse ? _ctx.attachResponse.status : 'info',
      onClose: _cache[2] || (_cache[2] = $event => _ctx.notificationShown = false)
    }, {
      default: withCtx(() => [_ctx.attachResponse && _ctx.attachResponse.showReloginLink ? (openBlock(), createElementBlock("a", {
        key: 0,
        "data-test": "log-in-as-multi-user-button",
        href: "#",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.signOut())
      }, toDisplayString(_ctx.translate('logInAsMultiUser')), 1 /* TEXT */)) : createCommentVNode("v-if", true), createTextVNode(" " + toDisplayString(_ctx.attachResponse.message), 1 /* TEXT */)]),

      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["variant"])]),
    _: 1 /* STABLE */
  })) : createCommentVNode("v-if", true)]);
}

script.render = render;
script.__file = "src/components/AuthPopover.vue";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
const types = {
  AUTH_INIT: 'AUTH_INIT',
  AUTH_SUCCESS: 'AUTH_SUCCESS',
  AUTH_ERROR: 'AUTH_ERROR',
  AUTH_COOKIES_EXPIRED: 'AUTH_COOKIES_EXPIRED',
  AUTH_ANOTHER_USER: 'AUTH_ANOTHER_USER',
  AUTH_NO_RIGHTS: 'AUTH_NO_RIGHTS',
  GENERATE_FINGERPRINT: 'GENERATE_FINGERPRINT',
  SIGN_OUT: 'SIGN_OUT',
  TWO_FACTOR_CHECK: 'TWO_FACTOR_CHECK',
  UPDATE_REACTIVE_TOKEN: 'UPDATE_REACTIVE_TOKEN'
};
const cookieMonitorLogoutCallback = commit => () => {
  commit(types.AUTH_COOKIES_EXPIRED, true);
};
const cookieMonitorLoginCallback = (commit, state) => newUser => {
  if (!state.userId || get(newUser, 'userId', null) === state.userId) {
    if (state.cookiesExpired) {
      commit(types.AUTH_COOKIES_EXPIRED, false);
    }
    if (state.cookiesAnotherUser) {
      commit(types.AUTH_COOKIES_EXPIRED, true);
    }
  } else {
    if (!state.cookiesAnotherUser) {
      commit(types.AUTH_ANOTHER_USER);
    }
  }
  if ((newUser === null || newUser === void 0 ? void 0 : newUser.expire) < Date.now()) {
    expireOverlay.captureClick();
  } else if ((newUser === null || newUser === void 0 ? void 0 : newUser.expire) > Date.now() && expireOverlay.shown) expireOverlay.triggerClick();
};
const initializeAuthState = authService => {
  const state = {
    get token() {
      return authService.getUserToken();
    },
    reactiveToken: null,
    tokenExpireTime: null,
    accountId: null,
    username: null,
    userId: null,
    error: null,
    authorized: null,
    role: null,
    initialPath: null,
    twoFactorCheck: false,
    fingerPrint: null,
    multiUserId: null,
    identityProvider: null,
    cookiesExpired: false,
    cookiesAnotherUser: false,
    cookiesNoRights: false,
    permissions: null,
    isReadonly: false
  };
  const mutations = {
    [types.AUTH_COOKIES_EXPIRED](authState, value) {
      authState.cookiesExpired = value;
      authState.cookiesAnotherUser = false;
      authState.cookiesNoRights = false;
    },
    [types.AUTH_ANOTHER_USER](authState) {
      authState.cookiesExpired = false;
      authState.cookiesAnotherUser = true;
      authState.cookiesNoRights = false;
    },
    [types.AUTH_NO_RIGHTS](authState) {
      authState.cookiesExpired = false;
      authState.cookiesAnotherUser = false;
      authState.cookiesNoRights = true;
    },
    [types.AUTH_INIT](authState, initState) {
      var _a, _b;
      authState.accountId = get(initState, 'accountId', null);
      authState.username = get(initState, 'username', null);
      authState.userId = get(initState, 'userId', null);
      authState.role = get(initState, 'role', null);
      authState.authorized = get(initState, 'authorized', null);
      authState.error = get(initState, 'error', null);
      authState.initialPath = get(initState, 'initialPath');
      authState.identityProvider = get(initState, 'identityProvider', null);
      authState.multiUserId = get(initState, 'multiUserId');
      authState.permissions = get(initState, 'permissions');
      authState.reactiveToken = get(initState, 'token');
      authState.tokenExpireTime = get(initState, 'expire');
      authState.isReadonly = authState.role === 'USER' && !!((_b = (_a = authState.permissions) === null || _a === void 0 ? void 0 : _a.scope) === null || _b === void 0 ? void 0 : _b.includes('READONLY'));
    },
    [types.AUTH_SUCCESS](authState, authData) {
      authState.accountId = authData.accountId;
      authState.username = authData.username;
      authState.userId = authData.userId;
      authState.role = authData.role;
      authState.identityProvider = authData.identityProvider;
      authState.authorized = true;
      authState.error = null;
      authState.multiUserId = authData.multiUserId;
      authState.reactiveToken = authData.token;
      authState.tokenExpireTime = authData.expire;
    },
    [types.AUTH_ERROR](authState, error) {
      authState.error = error;
      authState.identityProvider = null;
    },
    [types.SIGN_OUT](authState) {
      authState.accountId = null;
      authState.username = null;
      authState.userId = null;
      authState.role = null;
      authState.authorized = false;
      authState.error = null;
      authState.initialPath = null;
      authState.multiUserId = null;
      authState.identityProvider = null;
      authState.reactiveToken = null;
      authState.tokenExpireTime = null;
    },
    [types.TWO_FACTOR_CHECK](authState, value) {
      authState.twoFactorCheck = value;
    },
    [types.GENERATE_FINGERPRINT](authState, fingerPrint) {
      authState.fingerPrint = fingerPrint;
    },
    [types.UPDATE_REACTIVE_TOKEN](authState, {
      reactiveToken,
      tokenExpireTime
    }) {
      authState.reactiveToken = reactiveToken;
      authState.tokenExpireTime = tokenExpireTime;
    }
  };
  const actions = {
    init({
      commit,
      state,
      dispatch
    }, {
      initialPath,
      token,
      allowGuestLogin = false,
      shouldNotSaveCookies = false
    }) {
      var _a;
      authService.tokenUpdateCallback = user => {
        dispatch('updateReactiveToken', user);
      };
      // if initial path starts with '/login' then replace it with '/'
      initialPath = initialPath.match(/^\/login/) ? '/' : initialPath;
      let userPromise;
      if (token) userPromise = authService.signInWithToken(token, allowGuestLogin, shouldNotSaveCookies);else if (((_a = authService._getUser) === null || _a === void 0 ? void 0 : _a.expire) < Date.now()) userPromise = authService.refreshUserToken();else userPromise = authService.validateUser();
      return userPromise.then(user => {
        // shared Ui case where we dont need to monitor cookie
        if (!shouldNotSaveCookies) {
          authService.monitorCookie(cookieMonitorLogoutCallback(commit), cookieMonitorLoginCallback(commit, state));
          authService.validateMultiUserToken().catch(console.warn);
        }
        commit(types.AUTH_INIT, assign({}, user, {
          authorized: true,
          initialPath
        }));
      }).catch(error => {
        var _a, _b, _c;
        if (((_c = (_b = (_a = error.cause) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message.includes('suspended')) || error.message.includes('suspended')) {
          window.location.href = `${authService.authUiUrl}/account/payments`;
          return;
        }
        commit(types.AUTH_INIT, {
          authorized: false,
          initialPath
        });
        if (error.errorType === 'NoRightsError') {
          commit(types.AUTH_NO_RIGHTS);
        }
        throw error;
      });
    },
    /**
      * TODO: Remove
      * @deprecated not being used
      */
    signIn({
      commit,
      state
    }, {
      credentials,
      keepLoggedIn,
      verificationCode,
      userToken,
      rememberTwoFactor
    }) {
      return authService.signIn({
        credentials,
        long: keepLoggedIn,
        verificationCode,
        userToken,
        rememberTwoFactor
      }).then(async result => {
        if (result.tokenType === 'multi-user' && !result.twoFactorCheck) {
          result = await authService.multiUserLoginUser({
            accountId: state.accountId,
            id: state.userId,
            long: keepLoggedIn
          });
        }
        if (result.twoFactorCheck) {
          commit(types.TWO_FACTOR_CHECK, true);
        } else {
          commit(types.AUTH_SUCCESS, result);
          authService.monitorCookie(cookieMonitorLogoutCallback(commit), cookieMonitorLoginCallback(commit, state));
        }
        return result;
      }).catch(error => {
        commit(types.AUTH_ERROR, error);
      });
    },
    /**
      * TODO: Remove
      * @deprecated not being used
      */
    signOut({
      commit
    }) {
      authService.signOut();
      authService.stopCookieMonitor();
      commit(types.SIGN_OUT);
    },
    async generateFingerPrint({
      commit
    }) {
      const fingerprint = await generateFingerPrint();
      commit(types.GENERATE_FINGERPRINT, fingerprint);
    },
    updateReactiveToken({
      commit
    }, {
      token,
      expire
    }) {
      commit(types.UPDATE_REACTIVE_TOKEN, {
        reactiveToken: token,
        tokenExpireTime: expire
      });
    }
  };
  return {
    namespaced: true,
    actions,
    state,
    mutations
  };
};

async function piniaAuthRouterMiddleware (to, store, authUrl) {
  const initialPath = to.path;
  if (to.meta.requiresAuth) {
    if (isNull(store.authorized)) {
      try {
        await store.init({
          initialPath
        });
      } catch (e) {
        console.error(e);
      }
    }
    if (!store.authorized && !store.cookiesNoRights) {
      const encodedRedirectPath = encodeURIComponent(window.location.href);
      const authPath = `${authUrl}/login?redirectPath=${encodedRedirectPath}`;
      window.location.replace(authPath);
    }
  }
}

export { ACCOUNTS_API_INJECTION_TOKEN, APP_CONFIG, AUTH_API_INJECTION_TOKEN, script as AuthPopover, initializeAuthState as AuthVuexModule, script$b as ExpirationOverlay, USERS_API_INJECTION_TOKEN, initializeAuthStore as createAuthStore, piniaAuthRouterMiddleware };
